import type { IconProps } from './../../models/icon';

export function MoneyBagIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M11.9999 23.1429C17.9906 23.1429 22.2698 21.0204 22.2698 16.2963C22.2698 11.1613 19.7023 7.73801 14.5674 5.17054L16.5871 2.56882C16.6897 2.39813 16.7454 2.20334 16.7484 2.00419C16.7515 1.80504 16.7019 1.60863 16.6045 1.43486C16.5072 1.26108 16.3657 1.11612 16.1943 1.01467C16.0229 0.913223 15.8278 0.858889 15.6286 0.857178H8.37119C8.17203 0.858889 7.97685 0.913223 7.80546 1.01467C7.63407 1.11612 7.49255 1.26108 7.39523 1.43486C7.29791 1.60863 7.24827 1.80504 7.25134 2.00419C7.2544 2.20334 7.31005 2.39813 7.41267 2.56882L9.4324 5.18765C4.29745 7.77225 1.72998 11.1956 1.72998 16.3305C1.72998 21.0204 6.00911 23.1429 11.9999 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M11.9999 23.1429C17.9906 23.1429 22.2698 21.0204 22.2698 16.2963C22.2698 11.1613 19.7023 7.73801 14.5674 5.17054L16.5871 2.56882C16.6897 2.39813 16.7454 2.20334 16.7484 2.00419C16.7515 1.80504 16.7019 1.60863 16.6045 1.43486C16.5072 1.26108 16.3657 1.11612 16.1943 1.01467C16.0229 0.913223 15.8278 0.858889 15.6286 0.857178H8.37119C8.17203 0.858889 7.97685 0.913223 7.80546 1.01467C7.63407 1.11612 7.49255 1.26108 7.39523 1.43486C7.29791 1.60863 7.24827 1.80504 7.25134 2.00419C7.2544 2.20334 7.31005 2.39813 7.41267 2.56882L9.4324 5.18765C4.29745 7.77225 1.72998 11.1956 1.72998 16.3305C1.72998 21.0204 6.00911 23.1429 11.9999 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M10.2857 16.3885C10.4948 16.6368 10.7581 16.8339 11.0553 16.9646C11.3524 17.0954 11.6756 17.1564 12 17.1428C12.4957 17.1766 12.9853 17.0168 13.3657 16.6971C13.7462 16.3774 13.9879 15.9227 14.04 15.4285C13.9879 14.9343 13.7462 14.4796 13.3657 14.1599C12.9853 13.8402 12.4957 13.6804 12 13.7142C11.5042 13.748 11.0146 13.5883 10.6342 13.2686C10.2537 12.9489 10.012 12.4941 9.95996 11.9999C10.0079 11.504 10.2484 11.0466 10.6298 10.7261C11.0112 10.4056 11.5032 10.2474 12 10.2856C12.3186 10.2661 12.6376 10.3175 12.9341 10.4361C13.2305 10.5547 13.4969 10.7375 13.7142 10.9714"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 17.1422V18.8736"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 8.55359V10.279"
        />
      </g>
    </svg>
  );
}
